// Increment whenever question meaning, option meaning, or score mappings change
// in a way that makes previously stored answer values incompatible.
export const CURRENT_QUIZ_VERSION = '4.0.0'; // v3 routing + per-track (Notion model v2)
export const CURRENT_MODEL_VERSION = '5.0.0'; // 8 EEMM tracks, 53 patterns
export const CURRENT_SCORING_REVISION = '2026-07-26.v3';
